<!-- ヘッダー -->
<mat-toolbar color="primary">
  <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()" *ngIf="isHandset$ | async">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <a docs-button mat-button routerLink='./history'>勤怠管理システム</a>
</mat-toolbar>


<mat-sidenav-container class="sidenav-container mobile-sidenav">
  <!-- サイドメニュー -->
  <mat-sidenav #drawer class="sidenav" fixedInViewport="false" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-user-info (menuClicked)="drawerClose()"></app-user-info>
  </mat-sidenav>
  <!-- コンテンツ -->
  <mat-sidenav-content class="mat-sidenav-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
